__turbopack_context__.v({
  "buttonAttachedSubtitle": "_2JnSJG_buttonAttachedSubtitle",
  "contentSection": "_2JnSJG_contentSection",
  "contentTextContainer": "_2JnSJG_contentTextContainer",
  "cta": "_2JnSJG_cta",
  "heroFadeIn": "_2JnSJG_heroFadeIn",
  "heroSection": "_2JnSJG_heroSection",
  "scrim": "_2JnSJG_scrim",
  "subtitle": "_2JnSJG_subtitle",
  "title": "_2JnSJG_title",
});
